import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-c9ebf8b0")

_pushScopeId("data-v-c9ebf8b0")
const _hoisted_1 = { class: "field" }
const _hoisted_2 = { class: "label is-inline-flex is-align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", null, "Previous Registration Number", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", { class: "fas fa-info-circle" })
], -1)
const _hoisted_5 = { class: "field prev-registration-container" }
const _hoisted_6 = { class: "control is-expanded is-flex-grow-1 is-flex-shrink-1 " }
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "Link", -1)
const _hoisted_8 = /*#__PURE__*/_createVNode("span", { class: "icon" }, [
  /*#__PURE__*/_createVNode("i", {
    class: "fas fa-link",
    title: "Link"
  })
], -1)
const _hoisted_9 = {
  key: 1,
  class: "tag is-expanded control is-medium prev-reg-number-container"
}
const _hoisted_10 = { class: "prev-reg-dialog-container" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_tooltip = _resolveComponent("tooltip")
  const _component_prev_reg_dialog = _resolveComponent("prev-reg-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode("label", _hoisted_2, [
        _hoisted_3,
        (!_ctx.isPrevRegSelected)
          ? (_openBlock(), _createBlock(_component_tooltip, {
              key: 0,
              class: "is-inline prev-reg-tooltip-label ml-2",
              content: _ctx.tooltipContent,
              position: 'bottom',
              filter: 'span'
            }, {
              default: _withId(() => [
                _hoisted_4
              ]),
              _: 1
            }, 8, ["content"]))
          : _createCommentVNode("", true)
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          (!_ctx.isPrevRegSelected)
            ? (_openBlock(), _createBlock("button", {
                key: 0,
                disabled: !_ctx.isPrevRegistrationActive,
                type: "button",
                class: "button is-info is-outlined is-rounded is-small",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.showPrevDialog = true))
              }, [
                _hoisted_7,
                _hoisted_8
              ], 8, ["disabled"]))
            : _createCommentVNode("", true),
          (_ctx.isPrevRegSelected)
            ? (_openBlock(), _createBlock("span", _hoisted_9, [
                _createTextVNode(_toDisplayString(_ctx.previousRegistration.registrationNumber) + " ", 1),
                _createVNode("button", {
                  type: "button",
                  title: "Unlink",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.updatePrevReg(null))),
                  class: "delete is-small prev-reg-unlink-button"
                })
              ]))
            : _createCommentVNode("", true)
        ])
      ])
    ]),
    _createVNode("div", _hoisted_10, [
      _createVNode(_component_prev_reg_dialog, {
        prevRegistrationCriteria: _ctx.prevRegistrationCriteria,
        isVisible: _ctx.showPrevDialog,
        onDone: _cache[3] || (_cache[3] = ($event: any) => (_ctx.showPrevDialog = false)),
        onSelected: _cache[4] || (_cache[4] = ($event: any) => (_ctx.updatePrevReg($event)))
      }, null, 8, ["prevRegistrationCriteria", "isVisible"])
    ])
  ], 64))
})